import { render, staticRenderFns } from "./VehicleAvatarWithArc.vue?vue&type=template&id=1fda5604&lang=pug&"
import script from "./VehicleAvatarWithArc.vue?vue&type=script&lang=ts&"
export * from "./VehicleAvatarWithArc.vue?vue&type=script&lang=ts&"
import style0 from "./VehicleAvatarWithArc.vue?vue&type=style&index=0&id=1fda5604&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports